<template>
  <div id="sidemenu">
    <div class="nav">
      <img
        src="@/assets/side_toggle.svg"
        v-show="!isMenuBar"
        class="toggle"
        @click="CloseSideMenu"
      />
      <img src="@/assets/qvf_logo.svg" class="logo" alt="" />
      <router-link to="/" class="nav-link" @click.native="CloseSideMenu"
        >Home</router-link
      >
      <router-link to="/about" class="nav-link" @click.native="CloseSideMenu"
        >About</router-link
      >
      <router-link to="/game" class="nav-link" @click.native="CloseSideMenu"
        >Game</router-link
      >
      <router-link to="/graphic" class="nav-link" @click.native="CloseSideMenu"
        >Graphic</router-link
      >
      <router-link to="/music" class="nav-link" @click.native="CloseSideMenu"
        >Music</router-link
      >
      <router-link to="/story" class="nav-link" @click.native="CloseSideMenu"
        >Story</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuBar: false,
    };
  },
  name: "SideMenu",
  methods: {
    CloseSideMenu() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
#sidemenu {
  width: 100%;
  height: 100%;
  margin-left: auto;
}
.toggle {
  width: 70px;
  height: 70px;
  margin-left: auto;
}

.logo {
  width: auto;
  height: 10vh;
  margin-left: auto;
  margin-right: 10px;
}
.nav {
  z-index: 6;
  display: flex;
  position: fixed;
  flex-direction: column;
  align-items: flex-end;
  background-color: white;
  height: auto;
  margin-left: auto;
  right: 0px;
  width: 100%;
  height: 100%;
  font-size: 5vh;
  justify-content: flex-start;

  a {
    position: relative;
    font-weight: bold;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.85);
    margin-left: auto;
    margin-right: 20px;
    text-align: right;
    width: 300px;
    border-bottom: solid;
    border-width: 1px;
    line-height: 100%;
    padding-bottom: 1vh;
    margin: 2vh;
    transition-duration: 0.3s;
    transition-property: color;

    &.router-link-exact-active {
      color: rgba(0, 0, 0, 0.85);
    }

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }

    &::before {
      position: absolute;
      top: -10px;
      right: -20px;
      bottom: 0;
      left: 0;
      z-index: -1;
      content: "";
      background: #333;
      transform-origin: right top;
      transform: scale(0, 1);
      transition: transform 0.3s;
    }
    &:hover::before {
      transform: scale(1, 1);
    }
  }
}
.nav-link {
  flex: 0;
}
</style>
